import React, { useState, useEffect } from 'react';

const HeroSection = ({ opacity, scrollToSection }) => {
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 768);
  const [lockedHeight, setLockedHeight] = useState(typeof window !== 'undefined' ? window.innerHeight : 768);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      // Only update height on desktop, keep it locked on mobile
      if (window.innerWidth > 768) {
        setLockedHeight(window.innerHeight);
      }
    };

    // Set initial values
    handleResize();
    // Lock the initial height on mobile
    if (window.innerWidth <= 768) {
      setLockedHeight(window.innerHeight);
    }
    
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
  <section
    id="home"
     className="fixed z-10 bg-gradient-to-br from-blue-900 via-black to-gray-900 overflow-hidden flex items-center justify-center"
     style={{ 
       opacity, 
       pointerEvents: opacity < 0.4 ? 'none' : 'auto',
       height: windowWidth <= 768 ? `${lockedHeight * 1.15}px` : '100vh', // Extend height by 10% to cover address bar space
       width: '100vw',
       top: 0,
       left: 0,
       // Prevent any internal resizing
       minHeight: windowWidth <= 768 ? `${lockedHeight * 1.15}px` : '100vh',
       maxHeight: windowWidth <= 768 ? `${lockedHeight * 1.15}px` : '100vh'
     }}
  >
    <div
      className="absolute inset-0 opacity-10"
      style={{
        backgroundImage: `radial-gradient(circle at 2px 2px, rgba(255,255,255,0.15) 1px, transparent 0)`,
        backgroundSize: '50px 50px'
      }}
    />
    <div className="relative z-10 flex flex-col md:flex-row items-center justify-center px-4 md:px-8 max-w-7xl mx-auto w-full gap-6 md:gap-20 py-4 md:py-0" 
         style={{ 
           minHeight: windowWidth <= 768 ? `${lockedHeight}px` : '100vh',
           height: windowWidth <= 768 ? `${lockedHeight}px` : '100vh',
           paddingBottom: windowWidth <= 768 ? '50px' : '0' // Push content down on mobile instead of moving whole section
         }}>
      {/* Text */}
      <div 
        className="flex-1 flex flex-col items-start text-left order-2 md:order-2"
        style={{
          width: windowWidth < 500 ? 'min(75vw, 400px)' : undefined,
          maxWidth: windowWidth < 500 ? 'min(75vw, 400px)' : undefined
        }}
      >
        <h1 
          className="font-black text-white mb-3 tracking-tight leading-none"
          style={{ 
            fontSize: windowWidth < 768 ? `clamp(32px, 7.5vw, 48px)` : `clamp(48px, 6.5vw, 86px)`,
            lineHeight: '0.85'
          }}
        >
          TOMMY<span className="block text-blue-400">ZHANG</span>
        </h1>
        <p 
          className="text-gray-300 font-light leading-relaxed mb-6"
          style={{ 
            fontSize: windowWidth < 768 ? `clamp(16px, 4vw, 22px)` : `clamp(22px, 1.5vw, 24px)` 
          }}
        >
          AEROSPACE & MECHATRONICS ENGINEER
        </p>
        <div 
          className="gap-3"
          style={{
            display: 'flex',
            flexDirection: windowWidth < 500 ? 'column' : 'row',
            width: windowWidth < 500 ? '100%' : 'auto'
          }}
        >
          <button
            onClick={() => scrollToSection('projects')}
            className="bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-400 transition-colors duration-300 shadow-sm md:px-6 md:py-3"
            style={{ 
              padding: windowWidth < 768 ? `clamp(8px, 2vw, 12px) clamp(16px, 4vw, 24px)` : undefined,
              fontSize: windowWidth < 768 ? `clamp(14px, 3.5vw, 18px)` : undefined
            }}
          >
            VIEW PROJECTS
          </button>
          <a
            href="/Tommy-Resume.pdf"
            download="Tommy-Zhang-Resume.pdf"
            className="border-2 border-white text-white font-semibold rounded-lg hover:bg-white hover:text-black transition-colors duration-300 shadow-sm md:px-6 md:py-3 inline-flex items-center justify-center gap-2"
            style={{ 
              padding: windowWidth < 768 ? `clamp(8px, 2vw, 12px) clamp(16px, 4vw, 24px)` : undefined,
              fontSize: windowWidth < 768 ? `clamp(14px, 3.5vw, 18px)` : undefined,
              textDecoration: 'none'
            }}
          >
            DOWNLOAD RESUME
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </a>
        </div>
      </div>
      {/* Image with fixed positioning to prevent movement */}
      <div className="flex-1 flex items-center justify-center order-1 md:order-1" 
           style={{ 
             position: windowWidth <= 768 ? 'relative' : 'relative',
             height: windowWidth <= 768 ? 'auto' : 'auto',
             transform: windowWidth <= 768 ? 'translateY(15px)' : 'none' // Move image down on mobile
           }}>
        <img
          src={require('../tommy.jpg')}
          alt="Hero Drone"
          className="object-cover rounded-2xl shadow-2xl border-4 border-blue-400 bg-black"
          style={{ 
            width: windowWidth < 768 ? 'min(75vw, 400px)' : `clamp(400px, 30vw, 480px)`,
            height: 'auto',
            aspectRatio: '1/1',
            margin: 'clamp(4px, 1vw, 12px)',
            transform: 'none',
            maxWidth: '100%',
            position: 'relative',
            top: '0',
            left: '0'
          }}
          loading="eager"
        />
      </div>
    </div>
    {/* scroll indicator removed */}
  </section>
  );
};

export default HeroSection;
